module.exports = __webpack_public_path__ + "img/smallrpg.93b15a60.jpg";